export default function (val) {
  return val.replace(/https?:/, '')
}
